import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'

import * as enums from '../enums'

import * as filter from './filter'

export const TRANSFORMER: ReturnType<
  typeof graphql.transformers.IN.object<
    ents.extra.rate.gl.Filter.Statement,
    graphql.schema.GeneralLedgerFilterStatementInput
  >
> = graphql.transformers.IN.object<
  ents.extra.rate.gl.Filter.Statement,
  graphql.schema.GeneralLedgerFilterStatementInput
>({
  connector: graphql.transformers.IN.nonNull(
    enums.statementConnector.TRANSFORMER,
  ),
  filters: graphql.transformers.IN.default(
    graphql.transformers.IN.lazy(() =>
      graphql.transformers.IN.list(filter.TRANSFORMER, {
        onNullish: 'remove',
      }),
    ),
    [],
  ),
})
